module.exports = __webpack_public_path__ + "img/devbg.c7c4e543.gif";